export default "__VITE_ASSET__Bva4qJV9__";